<template>
    <div id="transforms">
        <div :class="idx == item.id?'btn se':'btn'" v-for="item in controls" :key="item.id" @click.stop="transform(item)">{{item.operation}}</div>
    </div>
</template>

<script>
export default {
    props:["tileset"],
    data(){
        return {
            controls:[
                {
                    id:1,
                    operation:'x轴裁切左',
                },
                {
                    id:2,
                    operation:'x轴裁切右',
                },
                {
                    id:3,
                    operation:'y轴裁切前',
                },
                {
                    id:4,
                    operation:'y轴裁切后',
                },
                {
                    id:5,
                    operation:'z轴裁切上',
                },
                {
                    id:6,
                    operation:'z轴裁切下',
                },
                {
                    id:7,
                    operation:'盒子内裁切',
                },
                {
                    id:8,
                    operation:'盒子外裁切',
                },
                {
                    id:9,
                    operation:'取消裁切',
                },
            ],
            clippings:{}, // 裁切面集合
            planeEntys:[], // 切割面实体集合
            handler:null,
            selectedPlane:null,
            targetY:0.0,
            rotateY:0.0,
            idx:0
        }
    },
    mounted(){
        console.log(this.tileset);
        if(this.tileset){
            this.addClipPlanes()
        }
    },
    methods:{
        transform(control){
            this.idx = control.id
            this.removeClip()
            let _this = this
            switch(control.id){
                case 1:
                    console.log('x轴裁切左');
                    _this.selectClip(_this.clippings.xPlane)
                    break;
                case 2:
                    console.log('x轴裁切右');
                    _this.selectClip(_this.clippings.rxPlane)
                    break;
                case 3:
                    console.log('y轴裁切前');
                    _this.selectClip(_this.clippings.yPlane)
                    break;
                case 4:
                    console.log('y轴裁切后');
                    _this.selectClip(_this.clippings.ryPlane)
                    break;
                case 5:
                    console.log('z轴裁切上');
                    _this.selectClip(_this.clippings.zPlane)
                    break;
                case 6:
                    console.log('z轴裁切下');
                    _this.selectClip(_this.clippings.rzPlane)
                    

                    break;
                case 7:
                    console.log('盒子内裁切');
                    _this.selectClip(_this.clippings.boxPlaneIn)
                    break;
                case 8:
                    console.log('盒子外裁切');
                    _this.selectClip(_this.clippings.boxPlaneOut)
                    break;
                case 9:
                    console.log('取消裁切');
                    _this.removeClip()
                    break;
            }
            _this.initHndler()
        },
        addClipPlanes(){
            let xPlane = {
                left : 0,
            }

            let yPlane = {
                before : 0,
            }

            let zPlane = {
                up : 0,
            }

            let rxPlane = {
                right : 0,
            }

            let ryPlane = {
                after : 0,
            }

            let rzPlane = {
                down : 0,
            }

            let boxPlaneOut = {
                left : -20,
                right: -20,
                before : -20,
                after : -20,
                up : -20,
                down:-20,
            }

            let boxPlaneIn = {
                left : 20,
                right: 20,
                before : 20,
                after : 20,
                up : 20,
                down:20,
                unionClippingRegions:true
            }

            this.clippings = {
                xPlane,
                yPlane,
                zPlane,
                rxPlane,
                ryPlane,
                rzPlane,
                boxPlaneIn,
                boxPlaneOut,
            }
        },
        selectClip(planes){
            let _this = this
            console.log(planes);
            this.tileset.clippingPlanes = convenient._clipPlanes(planes)
            let boundingSphere = _this.tileset.boundingSphere
            let arr = this.tileset.clippingPlanes
            for(let i = 0;i<arr.length;i++){
                let palne = arr._planes[i]
                console.log(palne);
                let planeEntity = viewer.entities.add({
                    name:'平面' + i,
                    position:boundingSphere.center,
                    plane:{
                        dimensions:new Cesium.Cartesian2(40, 40),
                        material:Cesium.Color.BLUE.withAlpha(0.1),
                        plane:new Cesium.CallbackProperty(createPlaneUpdateFunction(palne),false),
                        outline:true,
                        outlineColor:Cesium.Color.WHITE
                    }
                })
                _this.planeEntys.push(planeEntity)
            }

            function createPlaneUpdateFunction(plane) {
                return function () {
                    plane.distance = _this.targetY;
                    // plane._normal.y = _this.rotateY
                    // console.log(plane);
                    return plane;
                };
            }

            // let arrowX = viewer.entities.add({
            //     name:'arrowx',
            //     polyline:{
            //         position:new Cesium.Cartesian3(boundingSphere.center),
            //         width:25,
            //         arcType:Cesium.ArcType.NONE,
            //         material:new Cesium.PolylineArrowMaterialProperty(Cesium.Color.RED)
            //     }  
            // })
            // console.log(arrowX);
            // viewer.zoomTo(arrowX)
        },
        removeClip(){
            let noClippingPlanes = new Cesium.ClippingPlaneCollection({
                planes: [],
                edgeColor: Cesium.Color.WHITE,
                edgeWidth:1
            })
            this.tileset.clippingPlanes = noClippingPlanes
            this.planeEntys.forEach(item =>{
                viewer.entities.remove(item)
            })
        },
        initHndler(){
            let _this = this
            this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            this.handler.setInputAction((moment)=>{
                let pick = viewer.scene.pick(moment.position)
                console.log(pick);
                if (
                    Cesium.defined(pick) &&
                    Cesium.defined(pick.id) &&
                    Cesium.defined(pick.id.plane)
                ) {
                    _this.selectedPlane = pick.id.plane;
                    _this.selectedPlane.material = Cesium.Color.WHITE.withAlpha(0.05);
                    _this.selectedPlane.outlineColor = Cesium.Color.ORANGE;
                    viewer.scene.screenSpaceCameraController.enableInputs = false;
                }
            }, Cesium.ScreenSpaceEventType.LEFT_DOWN)

            this.handler.setInputAction((moment)=>{
                if (Cesium.defined(_this.selectedPlane)) {
                    _this.selectedPlane.material = Cesium.Color.WHITE.withAlpha(0.1);
                    _this.selectedPlane.outlineColor = Cesium.Color.WHITE;
                    _this.selectedPlane = undefined;
                }

                viewer.scene.screenSpaceCameraController.enableInputs = true;
            }, Cesium.ScreenSpaceEventType.LEFT_UP)

            this.handler.setInputAction((moment)=>{
                if (Cesium.defined(_this.selectedPlane)) {
                    console.log(moment);
                    let deltaY = moment.startPosition.y - moment.endPosition.y;
                    let rotate = moment.startPosition.x - moment.endPosition.x;
                    console.log(deltaY, rotate);
                    this.targetY += deltaY;
                    // this.rotateY += rotate * 0.2
                    console.log(this.targetY);
                }
            }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)

        }

    }
}
</script>

<style lang="less" scoped>
    #transforms{
        position: fixed;
        left: 1vw;
        top: 5vh;
        width: 5vw;
        height: 45vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .btn{
            width: 100%;
            text-align: center;
            background: #fff;
            border-radius: 5px;
            color: #000;
            font-weight: bold;
        }
        .se{
            background: #ffffff2b;
            color: #fff;
        }
    }

</style>